import React, { useRef, useState } from 'react'

import { useApplicationContext } from '../../contexts/appContext'
import { Layout, Header, LoadingDialog, ErrorDialog } from '@verifier-user/verifier-cdr'
import { EastVenturesIntro } from './EastVenturesIntro'
import { EnergyIntro } from './EnergyIntro'
import { IncomeIntro } from './IncomeIntro'
import { AngleIntro } from './AngleIntro'
import { BavIntro } from './BavIntro'
import { BMIntro } from './BMIntro'

export const Login = ({ vendorSettings }) => {
  const [error, setError] = useState(null)
  const [errorShown, setErrorShown] = useState(false)
  const [processing, setProcessing] = useState(false)
  const containerRef = useRef(null)
  const currentErrorRef = useRef(null)

  const { vendorData, isAuthenticated, logout } = useApplicationContext()

  const components = {
    EastVenturesIntro,
    IncomeIntro,
    EnergyIntro,
    BavIntro,
    AngleIntro,
    BMIntro
  }

  const getIntroComponent = () => {
    const IntroComponent = components[vendorData.introComponent]
    return (
      <IntroComponent
        vendorSettings={vendorSettings}
        currentErrorRef={currentErrorRef}
        setProcessing={setProcessing}
        setError={setError}
        setErrorShown={setErrorShown}
      />
    )
  }

  return (
    <>
      {vendorSettings?.viewSettings?.header && <Header vendorSettings={vendorSettings} />}
      <Layout vendorSettings={vendorSettings} isAuthenticated={isAuthenticated} logout={logout}>
        <div ref={containerRef}>
          <LoadingDialog id={'fnf-login'} isOpen={processing} />
          <ErrorDialog
            id='fnfCode'
            error={error}
            title={currentErrorRef.current && currentErrorRef.current.title}
            open={errorShown}
            setOpen={setErrorShown}
            showContent={true}
            cancelHandler={currentErrorRef.current && currentErrorRef.current.cancelFunction}
            okTitle={
              currentErrorRef.current && currentErrorRef.current.okTitle ? currentErrorRef.current.okTitle : 'Ok'
            }
            cancelTitle={
              currentErrorRef.current && currentErrorRef.current.cancelTitle
                ? currentErrorRef.current.cancelTitle
                : 'Cancel'
            }
            retryHandler={currentErrorRef.current ? currentErrorRef.current.retryFunction : undefined}
          >
            {currentErrorRef.current && currentErrorRef.current.errorContent}
          </ErrorDialog>

          {getIntroComponent()}
        </div>
      </Layout>
    </>
  )
}
